export function StatsCard({ title, items }) {

  return (
    <div
      style={{
        backgroundColor: '#ffffff',
        borderRadius: 12,
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        padding: 24,
        margin: 15,
      }}
    >
      <h3
        style={{
          fontWeight: 600,
          color: '#111827',
          marginBottom: 16,
          paddingBottom: 8,
          borderBottom: '1px solid #e5e7eb',
        }}
      >
        {title}
      </h3>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 12,
        }}
      >
        {items.map((item, index) => (
          <div
            key={index}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <span style={{ color: '#374151' }}>
              {item.label}
            </span>

            <span
              style={{
                color: '#111827',
                fontWeight: 500,
              }}
            >
              {item.value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}